var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex justify-content-center align-items-center",staticStyle:{"height":"300px"}},[(_vm.data.length > 0)?_c('div',{ref:"piechart",staticStyle:{"width":"100%"},style:(`height: ${_vm.height}`)}):_c('div',{staticStyle:{"text-align":"center"}},[_vm._v("No Data Available")])])
}
var staticRenderFns = []

export { render, staticRenderFns }